import { CookieService } from "widgets-module/services/cookie.service";

export class FavouritesStorage {

    private readonly _cookieService = new CookieService();
    private readonly _cookieName: string;
    private readonly _cookieSplitter: string;
    private readonly _cookieSettings = {
        expires: new Date().setDate(365) // sliding expiration
    };

    public constructor(cookieName: string, cookieSplitter: string) {
        this._cookieName = cookieName;
        this._cookieSplitter = cookieSplitter;
    }

    public add(pageKey: string): void {
        const favourites = this.getFavourites();
        if (favourites.includes(pageKey)) {
            return;
        }
        favourites.push(pageKey);
        this.setFavourites(favourites);
    }

    public remove(pageKey: string): void {
        const favourites = this.getFavourites().filter(x => x !== pageKey);
        this.setFavourites(favourites);
    }

    public has(pageKey: string): boolean {
        return this.getFavourites().includes(pageKey);
    }

    private getFavourites(): Array<string> {
        const favourites = this._cookieService.get(this._cookieName);
        if (!favourites) {
            return new Array<string>();
        }
        return favourites.split(this._cookieSplitter);
    }

    private setFavourites(favourites: Array<string>): void {
        const favouritesCookie = favourites.join(this._cookieSplitter);
        this._cookieService.set(this._cookieName, favouritesCookie, this._cookieSettings);
    }
}
